

















import { Component,  Vue } from 'vue-property-decorator';  
import {mapState} from 'vuex' 

@Component({ 
  computed: mapState([ 
    'carrinho' 
  ]), 
})

export default class SubTotal extends Vue {  
  
  get total() { 
      const carrinho: number = this.$store.state.carrinho.reduce((acc, b) => (acc + b.priceMember * b.quantity),0)
      return carrinho.toFixed(2)
  }
}
